export const SET_PRODUCT = 'SET_PRODUCT'
export const RESET_PRODUCT = 'RESET_PRODUCT'
